import * as requestFromServer from "./invoicesCrud";
import { callTypes, invoicesSlice } from "./InvoicesSlice";

const { actions } = invoicesSlice;

export const fetchInvoices = (queryParams) => (dispatch) => {
    dispatch(actions.startCall({ callType: callTypes.list }));

    return requestFromServer
        .FindInvoices(queryParams)
        .then((response) => {
            const { totalCount, entities } = response.data;
            dispatch(actions.invoicesFetched({ totalCount, entities }));
        })
        .catch((error) => {
            error.clientMessage = "رکورد های درخواستی یافت نشد.";
            dispatch(actions.catchError({ error, callType: callTypes.list }));
        });
};

export const fetchInvoice = (id) => (dispatch) => {
    dispatch(actions.startCall({ callType: callTypes.action }));

    return requestFromServer
        .GetInvoiceById(id)
        .then((response) => {
            const invoice = response.data;
            dispatch(actions.invoiceFetched({ invoiceToView: invoice }));
        })
        .catch((error) => {
            error.clientMessage = "فاکتور درخواستی یافت نشد";
            dispatch(actions.catchError({ error, callType: callTypes.action }));
        });
};

export const createInvoice = (invoiceForCreation) => (dispatch) => {
    dispatch(actions.startCall({ callType: callTypes.action }));

    return requestFromServer
        .CreateInvoice(invoiceForCreation)
        .then((response) => {
            const invoice = response.data;
            dispatch(actions.invoiceCreated({ invoice }));
        })
        .catch((error) => {
            error.clientMessage = "خطایی هنگام ایجاد فاکتور رخ داد";
            dispatch(actions.catchError({ error, callType: callTypes.action }));
        });
};

export const updateInvoice = (invoiceForCreation) => (dispatch) => {
    dispatch(actions.startCall({ callType: callTypes.action }));

    return requestFromServer
        .UpdateInvoice(invoiceForCreation)
        .then((response) => {
            const invoice = response.data;
            dispatch(actions.invoiceFetched({ invoice }));
        })
        .catch((error) => {
            error.clientMessage = "خطایی هنگام تغییر فاکتور رخ داد";
            dispatch(actions.catchError({ error, callType: callTypes.action }));
        });
};

export const deleteInvoice = id => dispatch => {
    dispatch(actions.startCall({ callType: callTypes.action }));
    return requestFromServer
        .DeleteInvoice(id)
        .then(() => {
            dispatch(actions.invoiceDeleted(id));
        })
        .catch((error) => {
            error.clientMessage = 'خطایی هنگام پاک کردن بازرسی رخ داد.';
            dispatch(actions.catchError({ error, callType: callTypes.action }));
        })
}
